module.exports = __webpack_public_path__ + "img/video-page-1.b7e532e1.png";